<div>
  <img class="h-16 block" src="/assets/brand/logo-symbol.png" alt="App Logo" loading="eager" />
</div>
<mat-spinner indeterminate [diameter]="32" class="mt-8"></mat-spinner>